import {Injectable} from '@angular/core';
import {environment} from '@Env/environment';
import {HttpClient} from '@angular/common/http';
import {DirCmpEntite} from './dircmp.model';
import {DaoGenericWithStorage} from 'app/archivage/common/helper/helperDaoGeneric';


/**
 * Direction et Composantes : acronyme / référent
 */
@Injectable({ providedIn: 'root' })
export class DirCmpArchiveService extends DaoGenericWithStorage<DirCmpEntite> {
  private url = `${environment.baseUrl}/api_archive/dir_cmp_entities/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.url;
  }
  public sortBy(entites: DirCmpEntite[], property = 'name') {
    entites.sort((x, y) =>
      (x.entite_archivage_obj?.entite_obj[property] < y.entite_archivage_obj?.entite_obj[property] ? -1 : 1));
  }
}
